import { createRouter, createWebHistory } from 'vue-router'
import signList from '@/views/XiaomiSign.vue'
import activityPage from '@/views/ActivityPage.vue'
import activityXPage from '@/views/ActivityXPage.vue'
import configPage from '@/views/ConfigPage.vue'
import viewPage from '@/views/ViewPage.vue'
import activityPageList from '@/views/AcitivityPageList.vue'
import loginPage from '@/views/LoginPage.vue'
import { isLoggedIn } from '@/utils/auth'

const routes = [
  { path: '/', redirect: '/activity' }, // 默认重定向到 /a
  { path: '/sign', component: signList },
  { path: '/activity', component: activityPage },
  { path: '/x/activity', component: activityXPage },
  { path: '/config', component: configPage },
  { path: '/view', component: viewPage },
  { path: '/pages', component: activityPageList, meta: { requiresAuth: true } },
  { path: '/login', component: loginPage }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isLoggedIn()) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
